<template>
  <div>
    <div class="columns is-multiline">
      <div class="column is-12 titleCard is-flex is-align-items-center">
        <h2 class="title is-4">Archivos adjuntos</h2>
      </div>

      <div class="column is-12 separator"></div>

      <div class="column is-12">
        <div>
          <div class="field">
            <label class="label">Subir archivos</label>
            <input class="input" type="file" multiple @change="handleFiles">
          </div>
          <button
            class="button is-info mt-2"
            :disabled="filesToUpload.length === 0"
            @click="uploadFiles"
          >
            Subir archivos
          </button>
        </div>
      </div>

      <div class="column is-12 separator"></div>

      <div class="column is-12">
        <h3 class="title is-5">Archivos cargados</h3>
        <div v-if="isLoading">
          <p>Cargando archivos...</p>
        </div>
        <div v-else-if="uploadedFiles.length === 0">
          <p class="has-text-grey">No hay archivos cargados.</p>
        </div>
        <div v-if="nonImageFiles.length > 0">
          <h4 class="title is-6 mt-4">Documentos</h4>
          <div class="file-grid">
            <div
              v-for="file in nonImageFiles"
              :key="file.id"
              class="file-card"
            >
              <span class="file-icon">📄</span>
              <a :href="file.fileUrl" target="_blank" class="file-name">
                {{ file.fileName }}
              </a>
            </div>
          </div>
        </div>

        <div v-if="imageFiles.length > 0">
          <h4 class="title is-6 mt-5">Imágenes</h4>
          <div class="image-grid">
            <div
              v-for="file in imageFiles"
              :key="file.id"
              class="image-card"
              @click="openImage(file.fileUrl)"
            >
              <img :src="file.fileUrl" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <ModalImage
      v-if="selectedImage"
      :image="selectedImage"
      :close="closeModal"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  props: {
    detail: { type: Object, required: true }
  },
  components: {
    ModalImage: () => import('@/components/Products/ModalImage')
  },
  data () {
    return {
      filesToUpload: [],
      uploadedFiles: [],
      isLoading: false,
      selectedImage: null
    }
  },
  computed: {
    imageFiles () {
      return this.uploadedFiles.filter(f => this.isImage(f.fileUrl))
    },
    nonImageFiles () {
      return this.uploadedFiles.filter(f => !this.isImage(f.fileUrl))
    }
  },

  methods: {
    ...mapActions(['getAdminAdditionalsFiles', 'uploadAdminAdditionalsFile']),
    handleFiles (event) {
      this.filesToUpload = Array.from(event.target.files)
    },
    isImage (url) {
      return /\.(jpg|jpeg|png|gif|webp)$/i.test(url)
    },
    async fetchFiles () {
      this.isLoading = true
      try {
        const response = await this.getAdminAdditionalsFiles({
          productId: this.detail.id
        })
        this.uploadedFiles = response.payload
      } catch (error) {
        console.error('Error al obtener archivos:', error)
      }
      this.isLoading = false
    },
    async uploadFiles () {
      try {
        const formData = new FormData()
        this.filesToUpload.forEach(file => formData.append('files', file))
        await this.uploadAdminAdditionalsFile({
          productId: this.detail.id,
          formData
        })
        this.filesToUpload = []
        await new Promise(resolve => setTimeout(resolve, 1500))
        await this.fetchFiles()
      } catch (error) {
        console.error('Error subiendo archivos:', error)
      }
    },
    openImage (url) {
      this.selectedImage = url
    },
    closeModal () {
      this.selectedImage = null
    }
  },

  async mounted () {
    this.fetchFiles()
  }
}
</script>
<style scoped>
.file-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 10px;
}

.file-card {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  border-radius: 6px;
  background: #f7f7f7;
  transition: background 0.2s;
  cursor: pointer;
  max-width: fit-content;
}

.file-card:hover {
  background: #e2e2e2;
}

.file-icon {
  margin-right: 10px;
  font-size: 1.5rem;
}

.file-name {
  font-weight: 600;
  color: #3273dc;
  word-break: break-all;
}

.image-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 15px;
  margin-top: 15px;
}

.image-card {
  cursor: pointer;
}

.image-card img {
  width: 100%;
  height: 120px;
  object-fit: cover;
  border-radius: 8px;
  box-shadow: 0px 2px 6px rgba(0,0,0,0.15);
  transition: transform 0.2s;
}

.image-card img:hover {
  transform: scale(1.05);
}

</style>
